import { NgModule } from '@angular/core';
import { PlatformRegistrationCountsComponent } from './platform-registration-counts.component';
import { ModalModule } from 'ngx-bootstrap/modal';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { MATERIALS } from '../../../../app.materials';
import {TooltipModule} from "ngx-bootstrap/tooltip";
import { DialogModule } from '../../../../dialog/dialog.module';
import { BaseModule } from '../../../../shared/base.module';
import { HighchartsChartModule } from 'highcharts-angular';
import { BreadcrumbModule } from '../../../../shared/breadcrumb/breadcrumb.module';
import { PlatformRegistrationCountsRouteModule } from './platform-registration-counts.routes';

@NgModule({
    imports: [
        MATERIALS,
        BaseModule,
        ModalModule.forRoot(),
        BsDropdownModule.forRoot(),
        TooltipModule.forRoot(),
        DialogModule,
        BreadcrumbModule,
        HighchartsChartModule,
        PlatformRegistrationCountsRouteModule
    ],
    declarations: [
        PlatformRegistrationCountsComponent
    ],
    exports: [
        PlatformRegistrationCountsComponent
    ],
    providers: [
    ]
})
export class PlatformRegistrationCountsModule {
}
